// extracted by mini-css-extract-plugin
export default {"hud":"DebugHud_hud__YbbhB"};